import { useEffect, useRef, useState } from 'react'

import cx from 'classnames'

import { StoreTypography } from '../typography/StoreTypography'

import styles from './cardRibbon.module.scss'

type Props = {
  content: string | undefined
  variant: string | undefined
}

export const CardRibbon = ({ content, variant }: Props) => {
  const ribbonRef = useRef<HTMLDivElement>(null)
  const hasDoublePoints = variant === '2x'
  const [ribbonWidth, setRibbonWidth] = useState(0)

  useEffect(() => {
    if (!hasDoublePoints) {
      return
    }

    const element = ribbonRef.current
    if (element) {
      const { width } = element.getBoundingClientRect()
      setRibbonWidth(width)
    }
  }, [hasDoublePoints])

  if (!content?.length) {
    return null
  }

  return (
    <div className={cx(styles.Container)}>
      {hasDoublePoints ? (
        <div className={styles.DoublePointsRibbonBg} style={{ width: ribbonWidth + 26 }}>
          <span>2x</span>
        </div>
      ) : null}
      <div className={styles.Shadow}>
        <div className={cx(styles.Ribbon, { [styles.hasDoublePoints]: hasDoublePoints })} ref={ribbonRef}>
          <StoreTypography tag="div" style="plain" textSize="sm" overrideFont="supercellTextBold">
            +{content}
          </StoreTypography>
        </div>
      </div>
    </div>
  )
}
